module.exports = __webpack_public_path__ + "img/ertiga-boostergreen-gls-blanco-perlado.3822bddb.png";